<template>
    <div :style="{width: windowInnerWidth, height: windowInnerHeight}">
        <SearchMainComponent />
    </div>
</template>

<script setup>

import SearchMainComponent from "@/components/phone/searchMainComponent.vue";
import {ref} from "vue";

const windowInnerWidth = ref((window.innerWidth) + "px")
const windowInnerHeight = ref((window.innerHeight) + "px")

</script>

<style scoped>

</style>